import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import Form from "../../form/components/Form/Form";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
import "./SelectUserModal.css";
import { Select } from 'antd';

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { collection, addDoc, getDoc, doc , updateDoc, arrayUnion } from "firebase/firestore";
// import { emai } from "firebase/auth";
import { db } from "../../../firebase/firebase-config";

const override = {
  marginTop: "20px",
};

let { Option } = Select;

function SelectUserModal({
  onClose,
  onContentAdded,
  selectedCase,
  speciaList,
  caseType,
  caseData
}: any) {
  const [error, setError] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAddUser = async (e:any) => {

    e.preventDefault()
    setLoading(true);
    // console.log(selectedUser)
    // console.log(selectedCase)
    // return;
    try{

    const docRef = doc(collection(db,"Cases"),selectedCase)
        
    // Use getDoc() to fetch the document
    const docSnapshot = await getDoc(docRef);

    if (!docSnapshot.exists()) {
      setLoading(false);
      toast.error("Document does not exist!", {
        pauseOnHover: false,
        closeOnClick: true,
      });
      throw new Error('Document does not exist!');
    }

    



    // Update the document with the modified array
    if(caseType == 'Pathology') {
      let  user = speciaList.find((data: any) => data.email ==  selectedUser)
      if(user.speciality  == 'pt' || user.role  == 'pt' || user.speciality  == 'Pathology'){
        await updateDoc(docRef, {
          access: arrayUnion(selectedUser),
        });
        setLoading(false);
        toast.success("New Reviewer Added", {
          pauseOnHover: false,
          closeOnClick: true,
        });
      }else {
        setLoading(false);
        toast.error("Selected Specialist Can not be assigned to this case.", {
          pauseOnHover: false,
          closeOnClick: true,
        });
      }
     
    }else if(caseType == 'Blood Pressure Tracking' || caseType == 'Blood Sugar Tracking') {
      let  user = speciaList.find((data: any) => data.email ==  selectedUser)
      if(user.speciality  == 'cardiologist' || user.speciality  == 'diabetologist' || user.speciality == 'gp') {
        await updateDoc(docRef, {
          doctor_uid: arrayUnion(user?.id),
        });
        setLoading(false);
        toast.success("New Reviewer Added", {
          pauseOnHover: false,
          closeOnClick: true,
        });
      }else {
        setLoading(false);
        toast.error("Selected Specialist Can not be assigned to this case.", {
          pauseOnHover: false,
          closeOnClick: true,
        });
      }
    } else {
      let  user = speciaList.find((data: any) => data.email ==  selectedUser)
      await updateDoc(docRef, {
        doctor_uid: arrayUnion(user?.id),
      });
      setLoading(false);
      toast.success("New Reviewer Added", {
        pauseOnHover: false,
        closeOnClick: true,
      });
    }
 

    }catch(e:any){
      setLoading(false);
      console.error('Error updating array field:', error);
    }

    
    if(selectedUser)
      setLoading(false);
      onClose()
  };

  // SCRIPT
  // USERS DATA
  let usersData =  [
    {
      id: 'qDmMHHrFKwXXXRec5rESoXIX8972',
      emai: 'jamesdoe@gmail.com'
    },
    {
      id: 'RBDu3QALDoMDg9kazB7Dj9qop9j1',
      emai: 'frankdoe237@gmail.com'
    },
    {
      id: 'rQTDCKgZaxbzH01ilzq9K6NMmdw1',
      emai: 'frankdoe@gmail.com'
    },
    {
      id: '4MC8PZQowIYAwDVQVGjV0J6odl33',
      emai: '+237654451039@medarc.org'
    },
    {
      id: '4sM4Of2dopMmwOTSvvJDIYlVAfy1',
      emai: '+237696582104@medarc.org'
    },
    {
      id: '1Apx92LGnEZBhklmYjjIk8e3S1I2',
      emai: '+237679365244@medarc.org'
    },
    {
      id: '5PhoJ2j9vKYxhtiF8SoBQCDGCZm2',
      emai: '+237656872427@medarc.org'
    },
    {
      id: 'cnMrjwUKwBRcKVDEWNAffQhN7Qq1',
      emai: '+237680194677@medarc.org'
    },
    {
      id: 'KQotj146Aycz0EPy1UG3f2sURJe2',
      emai: '+237677511626@medarc.org'
    },
    {
      id: 'CAOFTWMXQ2fIa4RejvMKvR1VFSZ2',
      emai: '+237650967837@medarc.org'
    },
    {
      id: 'rcusSJpv1pPvQdcdprOZ9yqWXNa2',
      emai: '+237699158562@medarc.org'
    },
    {
      id: 'd1UkO3gCEPenFCEfpWsP3abx0Zn1',
      emai: '+237678528975@medarc.org'
    },
    {
      id: 'fX9VA1VJ3CdS2ofqqdapOcLfp0j2',
      emai: '+237653536586@medarc.org'
    },
    {
      id: 'myhLmHdlzaaf0AHyPM0kU830adf1',
      emai: 'lab2@gmail.com'
    },
    {
      id: 'RVKH6PozHMRGYEkynhlYKfXsedo2',
      emai: '+237676583325@medarc.org'
    },
    {
      id: 'c2RbLyCkgCZGlkqmV29hghI94eN2',
      emai: '+237652936118@medarc.org'
    },
    {
      id: 'MfPEX1xYNjfIUoCIfrXOK5qCPnJ2',
      emai: '+237672043732@medarc.org'
    },
    {
      id: 'Y0HMCVfweRWtHqvT0pQhrFPepOp2',
      emai: '+237699893057@medarc.org'
    },
    {
      id: '31eusW941wcoryoQ2osNVselKUu2',
      emai: '+237691896165@medarc.org'
    },
    {
      id: 'FcbUJEew3gSbpMzVs2UTpLQgzU32',
      emai: '+237620978794@medarc.org'
    },
    {
      id: 'BODTfHZNTnMcgedmolE37s1sUGd2',
      emai: 'lab@gmail.com'
    },
    {
      id: 'Suet8jSlCgXCqBZ96jupt2OA5Tw1',
      emai: 'doctor@gmail.com'
    },
    {
      id: 'T3THhGWufgXOQIGNTWZsZeTcufZ2',
      emai: 'user@gmail.com'
    },
    {
      id: 'DkMPTmiDDcOtUP4uM39318mYDT03',
      emai: 'admin@gmail.com'
    },
    {
      id: 'GbAcMLkANLSB5JuqxgH3RoX6nEN2',
      emai: 'romeomanghe37@gmail.com'
    },
    {
      id: 'j4cZgW8eA0cqcMevX8rSQhGXYBX2',
      emai: 'drjoel@gmscope.org'
    },
    {
      id: 'ptX4cOw9BIf4mO2kyNV4plonQim2',
      emai: 'demo@gmscope.org'
    },
    {
      id: 'piufJXo8RJelQT5lC7u0dG8Tk9K2',
      emai: 'blessing@gmail.com'
    },
    {
      id: '9iWsFOjLQMSHPncEnnszM7mLGi83',
      emai: 'cleverview7@gmail.com'
    },
    {
      id: 'JzMnzF1qLodn7gyFKDXYT8AUDig1',
      emai: 'sedoid@gmail.com'
    },
    {
      id: 'lji21c6Vn0WPV3MduZBEqAiv2Jo1',
      emai: 'conrad@gmail.com'
    },
    {
      id: '5AobZx6UqyLKiEbiyxo1ugZ2YTc2',
      emai: 'test@gmail.com'
    }
  ];


  async function runScript() {
    // const cases = await getDocs(collection(db, "Cases"));

  }

  let [caseAssignedUsers, setAssignedUsers] = useState<any>([])

  useEffect(() => {
    // console.log("CASE DATA", caseData)
    // console.log('DOCTORS: ', speciaList);
    if(caseData?.doctor_uid) {
      if(caseData?.doctor_uid?.length >= 1) {
        setAssignedUsers([...caseData?.doctor_uid])
      }else {
        setAssignedUsers([caseData?.doctor_uid])
      }
    }else {
      if(caseData?.access) {
        setAssignedUsers([...caseData?.access])
      }
      
    }
  },[]) 


  let [filteredSpecialist, setFilteredSpecialist] = useState([]);

  useEffect(() => {
    // console.log('CASE: ', speciaList);
    // console.log('DATA: ', caseType);

    if(caseType === 'Pathology') {
      let filteredData = speciaList.filter((d: any) => d.role == 'pt' && d.status == true);
      setFilteredSpecialist(filteredData);
    }else {
      let filteredData = speciaList.filter((d: any) => d.role != 'pt' && d.status == true);
      setFilteredSpecialist(filteredData);
    }

  },[])

  return (
    <div>
      <div className="modal-container" id='select-slide'>
        <div className="modal-head">
          <p className="modal-title">Add Case Slide Reviewer</p>
          <ImCancelCircle
            style={{ cursor: "pointer" }}
            onClick={onClose}
            size={22}
            color="#fff"
          />
        </div>
        <div className="modal-content">
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <BeatLoader
              color="#3080ED"
              loading={loading}
              cssOverride={override}
            />
          </div>
          <form action="" className="auth-form">
            {error && <ErrorMessage error={error} visible={true} />}

              <p className="label-text">Select Reviewer: </p>
              <Select
                   className={'slide_select'}
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Search to Select"
                    optionFilterProp="label"
                    popupClassName="dropDownItems"
                    filterOption={(input: any, option: any) =>{
                      // console.log(option)
                      return (option?.children as string)?.toLowerCase()?.includes((input as string)?.toLowerCase());
                    }}
                    onSelect={(val: any) => setSelectedUser(val)}
                    filterSort={(optionA, optionB) =>
                      (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                    }
                  >
                    
                  {filteredSpecialist.map((doc: any, index: any) => {
                     let isDisabled = caseAssignedUsers.indexOf(doc?.id) >= 0;
                     if(!isDisabled) {
                        isDisabled = caseAssignedUsers.indexOf(doc?.email) >= 0;
                      }
                    return <Option
                          disabled={isDisabled}  
                          style={{
                            backgroundColor: isDisabled ? '#4F5052' : '', 
                            color: isDisabled ? '#fff' : '',
                          }}
                          key={index} value={doc?.email}>
                        {doc?.username}
                      </Option>
                      })}
                  </Select>

              <br />
              <br />

              {!loading && (
                <>
                  {/* <Button
                    isOutLined={true}
                    isFullWidth={false}
                    title="ADD REVIEWER"
                    onClick = {handleAddUser}
                  /> */}

                  <button
                    onClick = {handleAddUser}
                    style={{
                      padding: 15,
                      border: "1px solid #000",
                      borderRadius: 5,
                      backgroundColor: "white",
                      textTransform: "uppercase",
                      cursor: 'pointer',
                      color: "#000",
                    }}
                  >
                    ADD REVIEWER
                  </button>

                  <button
                    onClick={onClose}
                    style={{
                      padding: 15,
                      width: 100,
                      marginLeft: 25,
                      cursor: 'pointer',
                      border: "1px solid gray",
                      borderRadius: 5,
                      backgroundColor: "white",
                      textTransform: "uppercase",
                      color: "gray",
                    }}
                  >
                    Cancel
                  </button>
                </>
              )}

          </form>
        </div>
      </div>
      <div className="modal-shadow" onClick={onClose}></div>
    </div>
  );
}

export default SelectUserModal;
